// import { Col, Drawer, Row, TimePicker } from 'antd'
// import React, { useEffect, useState } from 'react'
// import '../userProfileAttendanceDetailsV3.css'
// import { CloseOutlined } from '@ant-design/icons'
// import moment from 'moment/moment';
// import AnimatedDatePicker from 'components/AnimatedDatePicker';
// import AnimatedTimePicker from 'components/AnimatedTimePicker';
// import AnimatedTextField from 'components/AnimatedTextField';
// import { Button } from 'components/Button';
// import { requestLeaveOrAttendance } from 'actions/profileNew';
// import { connect } from 'react-redux';


// const MarkAttendanceDrawer = ({ markDrawerVisible, setMarkDrawerVisible, setAttendanceFormDetails, attendanceFormDetails, userId, requestLeaveOrAttendance }) => {
//     const [buttonLoader, setButtonLoader] = useState(false);


//     useEffect(() => {
//         var dif = moment.duration(attendanceFormDetails.clockOut?.diff(attendanceFormDetails.clockIn));

//         attendanceFormDetails.totalHours = ("0" + dif.hours()).slice(-2) + ":" + ("0" + dif.minutes()).slice(-2);
//         setAttendanceFormDetails({ ...attendanceFormDetails })
//     }, [attendanceFormDetails.clockIn, attendanceFormDetails.clockOut]);

//     const onClose = (e) => {
  
//         setMarkDrawerVisible(false);
//         setAttendanceFormDetails({
//             date: null,
//             clockIn: null,
//             clockOut: null,
//             totalHours: null,
//             reason: null
//         })
//     };

//     function disabledDate(current) {
//         return current && (current < moment().add(-4, "days") || current > moment().add(-1, "days"))
//     }


//     function onKeyDown(event) {
//         event.preventDefault();
//     };


//     const handleSaveClick = () => {
//         const params = {
//             userId: userId,
//             // commonId: attendanceFormDetails.commonId,
//             requestType: "Attendance",
//             startDate: moment(attendanceFormDetails.date).format("YYYY-MM-DD"),
//             clockIn: moment(attendanceFormDetails.clockIn).format("HH:mm:ss"),
//             clockOut: moment(attendanceFormDetails.clockOut).format("HH:mm:ss"),
//             reason: attendanceFormDetails.reason,
//             totalhours: attendanceFormDetails.totalHours,
//             // page: 1,
//             // limit: filter.limit
//         }
    
//         setButtonLoader(true)
//         requestLeaveOrAttendance(params, () => {setButtonLoader(false)}, onClose, pagecallback)

//     }

//     const pagecallback = (state) => {
  
//     }
//     return (
//         <Drawer
//             placement="right"
//             onClose={onClose}
//             visible={markDrawerVisible}
//             width={450}
//             closable={false}
//         >
//             <div className='drawer-title'>
//                 <div style={{ fontWeight: 500, fontSize: 17 }}> Select range</div>
//                 <div><CloseOutlined style={{fontSize: 16, color: '#AEAEAE' }} onClick={onClose} /></div>
//             </div>
//             <div className='drawer-height'>
//                 <div className='mark-att-date-picker'>
//                     {/* <AnimatedDatePicker
//                         format='DD/MM/YYYY'
//                         style={{ width: "100%", border: 'none', borderBottom: '1px solid #E6E6E6' }}
//                         value={attendanceFormDetails.date}
//                         // value={moment(attendanceFormDetails.date, 'YYYY-MM-DD').format('DD-MM-YYYY')} 
//                         onChange={(value) => setAttendanceFormDetails({ ...attendanceFormDetails, date: value })}
//                         disabledDate={disabledDate}
//                         onKeyDown={onKeyDown}
//                     /> */}

//                     <AnimatedDatePicker
//                         inputReadOnly={true}
//                         label={"Date"}
//                         // inputId={"-999"}
//                         isMandatory={true}
//                         value={attendanceFormDetails.date}
//                         handleDateChange={(value) => setAttendanceFormDetails({ ...attendanceFormDetails, date: value })}

//                     />
//                 </div>
//                 <div>
//                     <Row className='p-20' style={{ paddingTop: 0 }}>
//                         <Col span={12}>
//                             <AnimatedTimePicker
//                                 inputReadOnly={true}
//                                 label={"In time"}
//                                 isMandatory={true}
//                                 value={attendanceFormDetails.clockIn}
//                                 handleTimeChange={(value) => setAttendanceFormDetails({ ...attendanceFormDetails, clockIn: value })}
//                             // isDisabled={!selectedOption}
//                             />
//                         </Col>
//                         <Col span={11} offset={1}>
//                             <AnimatedTimePicker
//                                 inputReadOnly={true}
//                                 label={"Out time"}
//                                 isMandatory={true}
//                                 value={attendanceFormDetails.clockOut}
//                                 handleTimeChange={(value) => setAttendanceFormDetails({ ...attendanceFormDetails, clockOut: value })}
//                             // isDisabled={!selectedOption}
//                             />
//                         </Col>
//                     </Row>
//                 </div>
//                 <div className='mark-reason'>
//                     <AnimatedTextField
//                         label={"Reason"}
//                         inputId={"-998"}
//                         isMandatory={true}
//                         value={attendanceFormDetails.reason}
//                         handleInputChange={(e) => setAttendanceFormDetails({ ...attendanceFormDetails, reason: e.target.value })}
//                     />
//                 </div>

//             </div>
//             <div
//                 style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: '0px 20px 0px 20px'
//                 }}
//             >

//                 <Button type="" style={{
//                     backgroundColor: "#FFFFFF", color: "#AEAEAE", borderRadius: 8, border: '2px solid #AEAEAE', display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     fontWeight: 500
//                 }}
//                     onClick={onClose} >CANCEL</Button>
//                 <Button

//                     // disabled={
//                     //     value === 6
//                     //         ? !startDateContainer || !endDateContainer
//                     //         : value === 0
//                     // }
//                     loading={buttonLoader}
//                     className="m-l-30"
//                     style={{
//                         borderRadius: 8,
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         backgroundColor: "#594099",
//                         color: '#FFFFFF',
//                         // opacity:
//                         //     value === 6
//                         //         ? !startDateContainer || !endDateContainer
//                         //             ? 0.5
//                         //             : 1
//                         //         : value === 0
//                         //             ? 0.5
//                         //             : 1,
//                     }}
//                     type="primary"
//                     onClick={handleSaveClick}
//                 >
//                     SAVE
//                 </Button>
//             </div>
//         </Drawer>
//     )
// }

// const mapStateToProps = (state) => {
//     const { user } = state.session;
//     const { leaveDetails } = state.profileNew;
//     const { userRowDetails } = state.userManagementV2;
//     return {
//         leaveDetails, user, userRowDetails
//     }
// }

// const mapDispatchToProps = (dispatch) => ({
//     requestLeaveOrAttendance: (params, callback, successCallback, pagecallback) => dispatch(requestLeaveOrAttendance(params, callback, successCallback, pagecallback)),
// })

// export default connect(mapStateToProps, mapDispatchToProps)(MarkAttendanceDrawer);

// import { Col, Drawer, Row, TimePicker } from 'antd'
// import React, { useEffect, useState } from 'react'
// import '../userProfileAttendanceDetailsV3.css'
// import { CloseOutlined } from '@ant-design/icons'
// import moment from 'moment/moment';
// import AnimatedDatePicker from 'components/AnimatedDatePicker';
// import AnimatedTimePicker from 'components/AnimatedTimePicker';
// import AnimatedTextField from 'components/AnimatedTextField';
// import { Button } from 'components/Button';
// import { requestLeaveOrAttendance } from 'actions/profileNew';
// import { connect } from 'react-redux';

// // Import Input component for Total Hours (if you have a custom one, else use antd Input)
// import { Input } from 'antd';

// const MarkAttendanceDrawer = ({ 
//     markDrawerVisible, 
//     setMarkDrawerVisible, 
//     setAttendanceFormDetails, 
//     attendanceFormDetails, 
//     userId, 
//     requestLeaveOrAttendance,
//     isEdit = false // Add this prop to determine if it's edit mode
// }) => {
//     const [buttonLoader, setButtonLoader] = useState(false);
//     const [isTotalHoursVisible, setIsTotalHoursVisible] = useState(false);

//     useEffect(() => {
//         // Calculate total hours when clockIn or clockOut changes
//         if (attendanceFormDetails.clockIn && attendanceFormDetails.clockOut) {
//             var dif = moment.duration(attendanceFormDetails.clockOut?.diff(attendanceFormDetails.clockIn));
            
//             // Check if clockOut is before clockIn
//             if (attendanceFormDetails.clockOut < attendanceFormDetails.clockIn) {
//                 attendanceFormDetails.totalHours = "00:00";
//             } else {
//                 attendanceFormDetails.totalHours = ("0" + dif.hours()).slice(-2) + ":" + ("0" + dif.minutes()).slice(-2);
//             }
//             setIsTotalHoursVisible(true);
//         } else {
//             attendanceFormDetails.totalHours = null;
//             setIsTotalHoursVisible(false);
//         }
//         setAttendanceFormDetails({ ...attendanceFormDetails })
//     }, [attendanceFormDetails.clockIn, attendanceFormDetails.clockOut]);

//     const onClose = (e) => {
//         setMarkDrawerVisible(false);
//         setAttendanceFormDetails({
//             date: null,
//             clockIn: null,
//             clockOut: null,
//             totalHours: null,
//             reason: null
//         })
//         setIsTotalHoursVisible(false);
//     };

//     function disabledDate(current) {
//         return current && (current < moment().add(-4, "days") || current > moment().add(-1, "days"))
//     }

//     function onKeyDown(event) {
//         event.preventDefault();
//     };

//     const handleSaveClick = () => {
//         const params = {
//             userId: userId,
//             requestType: "Attendance",
//             startDate: moment(attendanceFormDetails.date).format("YYYY-MM-DD"),
//             clockIn: moment(attendanceFormDetails.clockIn).format("HH:mm:ss"),
//             clockOut: moment(attendanceFormDetails.clockOut).format("HH:mm:ss"),
//             reason: attendanceFormDetails.reason,
//             totalhours: attendanceFormDetails.totalHours,
//         }
    
//         setButtonLoader(true)
//         requestLeaveOrAttendance(params, () => {setButtonLoader(false)}, onClose, pagecallback)
//     }

//     const pagecallback = (state) => {
//         // Handle page callback if needed
//     }

//     // Check if Save button should be disabled
//     const isSaveDisabled = () => {
//         return !attendanceFormDetails.date || 
//                !attendanceFormDetails.clockIn || 
//                !attendanceFormDetails.clockOut || 
//                !attendanceFormDetails.reason || 
//                attendanceFormDetails.reason.trim() === "" ||
//                attendanceFormDetails.clockOut < attendanceFormDetails.clockIn ||
//                attendanceFormDetails.totalHours === "00:00";
//     }
//     const handleReasonChange = (e) => {
//         const value = e.target.value;
//         setAttendanceFormDetails({ ...attendanceFormDetails, reason: value });
        
//         // Update label state based on value
//         const labelElement = document.getElementById(`customInputLabel_reason`);
//         if (labelElement) {
//             if (value && value.trim() !== '') {
//                 labelElement.classList.add('shrink');
//             } else {
//                 labelElement.classList.remove('shrink');
//             }
//         }
//     };
//     const handleReasonFocus = () => {
//         // Don't add shrink class on focus, only if there's a value
//         const labelElement = document.getElementById(`customInputLabel_reason`);
//         if (labelElement && attendanceFormDetails.reason && attendanceFormDetails.reason.trim() !== '') {
//             labelElement.classList.add('shrink');
//         }
//     };

//     const handleReasonBlur = () => {
//         // Remove shrink if no value
//         const labelElement = document.getElementById(`customInputLabel_reason`);
//         if (labelElement && (!attendanceFormDetails.reason || attendanceFormDetails.reason.trim() === '')) {
//             labelElement.classList.remove('shrink');
//         }
//     };

//     return (
//         <Drawer
//             placement="right"
//             onClose={onClose}
//             visible={markDrawerVisible}
//             width={450}
//             closable={false}
//         >
//             <div className='drawer-title'>
//                 <div style={{ fontWeight: 500, fontSize: 17 }}> Select range</div>
//                 <div><CloseOutlined style={{fontSize: 16, color: '#AEAEAE' }} onClick={onClose} /></div>
//             </div>
//             <div className='drawer-height'>
//                 <div className='mark-att-date-picker'>
//                     <AnimatedDatePicker
//                         inputReadOnly={true}
//                         label={"Date"}
//                         isMandatory={true}
//                         allowClear={true}
//                         value={attendanceFormDetails.date}
//                         handleDateChange={(value) => setAttendanceFormDetails({ ...attendanceFormDetails, date: value })}
//                         disabled={isEdit === 'edit'} // Disable date picker in edit mode
//                         disabledDate={disabledDate}
//                     />
//                 </div>
//                 <div>
//                     <Row className='p-20' style={{ paddingTop: 0 }}>
//                         <Col span={12}>
//                             <AnimatedTimePicker
//                                 inputId="inTime"
//                                 inputReadOnly={true}
//                                 label={"In time"}
//                                 isMandatory={true}
//                                 value={attendanceFormDetails.clockIn}
//                                 allowClear={true}
//                                 handleTimeChange={(value) => setAttendanceFormDetails({ ...attendanceFormDetails, clockIn: value })}
//                             />
//                         </Col>
//                         <Col span={11} offset={1}>
//                             <AnimatedTimePicker
//                                 inputId="outTime"
//                                 inputReadOnly={true}
//                                 label={"Out time"}
//                                 isMandatory={true}
//                                 allowClear={true}
//                                 value={attendanceFormDetails.clockOut}
//                                 handleTimeChange={(value) => setAttendanceFormDetails({ ...attendanceFormDetails, clockOut: value })}
//                                 disabled={!attendanceFormDetails.clockIn} // Disable out time if in time is not selected
//                             />
//                         </Col>
//                     </Row>
//                 </div>
                
//                 {/* Add Total Hours field - only show when both clock in and out are filled */}
//                 {/* {isTotalHoursVisible && (
//                     <div className='mark-reason' style={{ padding: '0 20px', marginBottom: 20 }}>
//                         <div style={{ marginBottom: 5, fontSize: 14, color: '#636363' }}>
//                             Total hours <span style={{ color: 'red' }}>*</span>
//                         </div>
//                         <Input 
//                             disabled 
//                             style={{ 
//                                 width: "100%", 
//                                 backgroundColor: '#F5F5F5',
//                                 color: '#636363',
//                                 borderRadius: 4
//                             }} 
//                             placeholder="Total Hours" 
//                             value={
//                                 attendanceFormDetails.clockIn > attendanceFormDetails.clockOut || 
//                                 attendanceFormDetails.totalHours === 'aN:aN' || 
//                                 !attendanceFormDetails.totalHours 
//                                     ? "00:00" 
//                                     : attendanceFormDetails.totalHours
//                             } 
//                         />
//                     </div>
//                 )} */}
//                 {isTotalHoursVisible && (
//                     <div className='mark-reason' style={{ padding: '0 20px', marginBottom: 20 }}>
//                         <div style={{ marginBottom: 5, fontSize: 14, color: '#AEAEAE' }}>
//                             Total hours <span style={{ color: 'red' }}>*</span>
//                         </div>
//                         <Input 
//                             disabled 
//                             style={{ 
//                                 width: "100%", 
//                                 backgroundColor: '#F5F5F5',
//                                 color: '#636363',
//                                 borderRadius: 4,
//                                 height: 40,
//                                 border: '1px solid #E6E6E6'
//                             }} 
//                             placeholder="Total Hours" 
//                             value={
//                                 attendanceFormDetails.clockIn > attendanceFormDetails.clockOut || 
//                                 attendanceFormDetails.totalHours === 'aN:aN' || 
//                                 !attendanceFormDetails.totalHours 
//                                     ? "00:00" 
//                                     : attendanceFormDetails.totalHours
//                             } 
//                         />
//                     </div>
//                 )}

//                 <div className='mark-reason'>
//                     <AnimatedTextField
//                         label={"Reason"}
//                         inputId={"-998"}
//                         isMandatory={true}
//                         value={attendanceFormDetails.reason}
//                         // handleInputChange={(e) => setAttendanceFormDetails({ ...attendanceFormDetails, reason: e.target.value })}
//                         handleInputChange={handleReasonChange}
//                         onFocus={handleReasonFocus}
//                         onBlur={handleReasonBlur}
//                     />
//                 </div>
//             </div>
//             <div
//                 style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     padding: '0px 20px 0px 20px'
//                 }}
//             >
//                 <Button 
//                     type="" 
//                     style={{
//                         backgroundColor: "#FFFFFF", 
//                         color: "#AEAEAE", 
//                         borderRadius: 8, 
//                         border: '2px solid #AEAEAE', 
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         fontWeight: 500
//                     }}
//                     onClick={onClose} 
//                 >
//                     CANCEL
//                 </Button>
//                 <Button
//                     loading={buttonLoader}
//                     className="m-l-30"
//                     style={{
//                         borderRadius: 8,
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         backgroundColor: "#594099",
//                         color: '#FFFFFF',
//                         opacity: isSaveDisabled() ? 0.5 : 1,
//                         cursor: isSaveDisabled() ? 'not-allowed' : 'pointer'
//                     }}
//                     type="primary"
//                     onClick={handleSaveClick}
//                     disabled={isSaveDisabled()}
//                 >
//                     SAVE
//                 </Button>
//             </div>
//         </Drawer>
//     )
// }

// const mapStateToProps = (state) => {
//     const { user } = state.session;
//     const { leaveDetails } = state.profileNew;
//     const { userRowDetails } = state.userManagementV2;
//     return {
//         leaveDetails, user, userRowDetails
//     }
// }

// const mapDispatchToProps = (dispatch) => ({
//     requestLeaveOrAttendance: (params, callback, successCallback, pagecallback) => dispatch(requestLeaveOrAttendance(params, callback, successCallback, pagecallback)),
// })

// export default connect(mapStateToProps, mapDispatchToProps)(MarkAttendanceDrawer);

import { Col, Drawer, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import '../userProfileAttendanceDetailsV3.css'
import { CloseOutlined } from '@ant-design/icons'
import moment from 'moment/moment';
import AnimatedDatePicker from 'components/AnimatedDatePicker';
import AnimatedTimePicker from 'components/AnimatedTimePicker';
import AnimatedTextField from 'components/AnimatedTextField';
import { Button } from 'components/Button';
import { requestLeaveOrAttendance } from 'actions/profileNew';
import { connect } from 'react-redux';
import { Input } from 'antd';

const MarkAttendanceDrawer = ({ 
    markDrawerVisible, 
    setMarkDrawerVisible, 
    setAttendanceFormDetails, 
    attendanceFormDetails, 
    userId, 
    requestLeaveOrAttendance,
    isEdit = false,
    // Called after a successful save (e.g. to refetch the attendance tab).
    onSaved,
}) => {
    const [buttonLoader, setButtonLoader] = useState(false);
    const [isTotalHoursVisible, setIsTotalHoursVisible] = useState(false);

    useEffect(() => {
        // Calculate total hours when clockIn or clockOut changes
        if (attendanceFormDetails.clockIn && attendanceFormDetails.clockOut) {
            var dif = moment.duration(attendanceFormDetails.clockOut?.diff(attendanceFormDetails.clockIn));
            
            // Check if clockOut is before clockIn
            if (attendanceFormDetails.clockOut < attendanceFormDetails.clockIn) {
                attendanceFormDetails.totalHours = "00:00";
            } else {
                attendanceFormDetails.totalHours = ("0" + dif.hours()).slice(-2) + ":" + ("0" + dif.minutes()).slice(-2);
            }
            setIsTotalHoursVisible(true);
        } else {
            attendanceFormDetails.totalHours = null;
            setIsTotalHoursVisible(false);
        }
        setAttendanceFormDetails({ ...attendanceFormDetails })
    }, [attendanceFormDetails.clockIn, attendanceFormDetails.clockOut]);

    const onClose = (e) => {
        setMarkDrawerVisible(false);
        setAttendanceFormDetails({
            date: null,
            clockIn: null,
            clockOut: null,
            totalHours: null,
            reason: null
        })
        setIsTotalHoursVisible(false);
    };

    function disabledDate(current) {
        return current && (current < moment().add(-4, "days") || current > moment().add(-1, "days"))
    }

    function onKeyDown(event) {
        event.preventDefault();
    };

    const handleSaveClick = () => {
        const params = {
            userId: userId,
            requestType: "Attendance",
            startDate: moment(attendanceFormDetails.date).format("YYYY-MM-DD"),
            clockIn: moment(attendanceFormDetails.clockIn).format("HH:mm:ss"),
            clockOut: moment(attendanceFormDetails.clockOut).format("HH:mm:ss"),
            reason: attendanceFormDetails.reason,
            totalhours: attendanceFormDetails.totalHours,
        }
    
        setButtonLoader(true)
        requestLeaveOrAttendance(params, () => {setButtonLoader(false)}, () => { onClose(); onSaved?.(); }, pagecallback)
    }

    const pagecallback = (state) => {
        // Handle page callback if needed
    }

    // Check if Save button should be disabled
    const isSaveDisabled = () => {
        return !attendanceFormDetails.date || 
               !attendanceFormDetails.clockIn || 
               !attendanceFormDetails.clockOut || 
               !attendanceFormDetails.reason || 
               attendanceFormDetails.reason.trim() === "" ||
               attendanceFormDetails.clockOut < attendanceFormDetails.clockIn ||
               attendanceFormDetails.totalHours === "00:00";
    }

    // Function to disable hours in clock out that are before clock in hour
    const disabledClockOutHours = () => {
        if (!attendanceFormDetails.clockIn) return [];
        const selectedHour = moment(attendanceFormDetails.clockIn).hour();
        const hours = [];
        for (let i = 0; i < selectedHour; i++) {
            hours.push(i);
        }
        return hours;
    };

    // Function to disable minutes in clock out when hour is same as clock in hour
    const disabledClockOutMinutes = (selectedHour) => {
        if (!attendanceFormDetails.clockIn) return [];
        const clockInHour = moment(attendanceFormDetails.clockIn).hour();
        const clockInMinute = moment(attendanceFormDetails.clockIn).minute();
        
        // Only disable minutes if the selected hour is the same as clock in hour
        if (selectedHour === clockInHour) {
            const minutes = [];
            for (let i = 0; i <= clockInMinute; i++) {
                minutes.push(i);
            }
            return minutes;
        }
        return [];
    };

    // Handle clock in change
    const handleClockInChange = (value) => {
        // Clear clock out when clock in changes
        setAttendanceFormDetails({ 
            ...attendanceFormDetails, 
            clockIn: value,
            clockOut: null // Clear clock out
        });
        setIsTotalHoursVisible(false);
    };

    // Handle clock out change
    const handleClockOutChange = (value) => {
        setAttendanceFormDetails({ ...attendanceFormDetails, clockOut: value });
    };

    // Reason field handlers - Fix label behavior
    const handleReasonChange = (e) => {
        const value = e.target.value;
        setAttendanceFormDetails({ ...attendanceFormDetails, reason: value });
    };

    return (
        <Drawer
            placement="right"
            onClose={onClose}
            visible={markDrawerVisible}
            width={450}
            closable={false}
        >
            <div className='drawer-title'>
                <div style={{ fontWeight: 500, fontSize: 17 }}> Mark attendance</div>
                <div><CloseOutlined style={{fontSize: 16, color: '#AEAEAE' }} onClick={onClose} /></div>
            </div>
            <div className='drawer-height'>
                <div className='mark-att-date-picker'>
                    <AnimatedDatePicker
                        inputReadOnly={true}
                        label={"Date"}
                        isMandatory={true}
                        allowClear={true}
                        value={attendanceFormDetails.date}
                        handleDateChange={(value) => setAttendanceFormDetails({ ...attendanceFormDetails, date: value })}
                        disabled={isEdit === 'edit'}
                        disabledDate={disabledDate}
                    />
                </div>
                <div>
                    <Row className='p-20' style={{ paddingTop: 0 }}>
                        <Col span={12}>
                            <AnimatedTimePicker
                                inputId="inTime"
                                inputReadOnly={true}
                                label={"In time"}
                                isMandatory={true}
                                value={attendanceFormDetails.clockIn}
                                allowClear={true}
                                format="HH:mm"
                                handleTimeChange={handleClockInChange}
                            />
                        </Col>
                        <Col span={11} offset={1} style={{ opacity: attendanceFormDetails.clockIn ? 1 : 0.5 }}>
                            <AnimatedTimePicker
                                inputId="outTime"
                                inputReadOnly={true}
                                label={"Out time"}
                                isMandatory={true}
                                allowClear={true}
                                format="HH:mm"
                                value={attendanceFormDetails.clockOut}
                                handleTimeChange={handleClockOutChange}
                                disabled={!attendanceFormDetails.clockIn}
                                disabledHours={disabledClockOutHours}
                                disabledMinutes={disabledClockOutMinutes}
                            />
                        </Col>
                    </Row>
                </div>
                
                {/* Total Hours field */}
                {isTotalHoursVisible && (
                    <div className='mark-reason' style={{ padding: '0 20px', marginBottom: 20 }}>
                        <div style={{ marginBottom: 5, fontSize: 14, color: '#AEAEAE' }}>
                            Total hours <span style={{ color: 'red' }}>*</span>
                        </div>
                        <Input 
                            disabled 
                            style={{ 
                                width: "100%", 
                                backgroundColor: '#F5F5F5',
                                color: '#636363',
                                borderRadius: 4,
                                height: 40,
                                border: '1px solid #E6E6E6'
                            }} 
                            placeholder="Total Hours" 
                            value={
                                attendanceFormDetails.clockIn > attendanceFormDetails.clockOut || 
                                attendanceFormDetails.totalHours === 'aN:aN' || 
                                !attendanceFormDetails.totalHours 
                                    ? "00:00" 
                                    : attendanceFormDetails.totalHours
                            } 
                        />
                    </div>
                )}

                <div className='mark-reason'>
                    <AnimatedTextField
                        label={"Reason"}
                        inputId={"reason"}
                        isMandatory={true}
                        value={attendanceFormDetails.reason}
                        handleInputChange={handleReasonChange}
                    />
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: '0px 20px 0px 20px'
                }}
            >
                <Button 
                    type="" 
                    style={{
                        backgroundColor: "#FFFFFF", 
                        color: "#AEAEAE", 
                        borderRadius: 8, 
                        border: '2px solid #AEAEAE', 
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 500
                    }}
                    onClick={onClose} 
                >
                    CANCEL
                </Button>
                <Button
                    loading={buttonLoader}
                    className="m-l-30"
                    style={{
                        borderRadius: 8,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: "#594099",
                        color: '#FFFFFF',
                        opacity: isSaveDisabled() ? 0.5 : 1,
                        cursor: isSaveDisabled() ? 'not-allowed' : 'pointer'
                    }}
                    type="primary"
                    onClick={handleSaveClick}
                    disabled={isSaveDisabled()}
                >
                    SAVE
                </Button>
            </div>
        </Drawer>
    )
}

const mapStateToProps = (state) => {
    const { user } = state.session;
    const { leaveDetails } = state.profileNew;
    const { userRowDetails } = state.userManagementV2;
    return {
        leaveDetails, user, userRowDetails
    }
}

const mapDispatchToProps = (dispatch) => ({
    requestLeaveOrAttendance: (params, callback, successCallback, pagecallback) => dispatch(requestLeaveOrAttendance(params, callback, successCallback, pagecallback)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MarkAttendanceDrawer);